module.exports = __webpack_public_path__ + "img/apple.75d3bf9d.png";